<template>
  <base-page-layout title="Faixas de preços" :filters="['lojas', 'produtos']" :check-all-units-on-init="false" hide-ecommerce-configuration>
    <v-row class="mt-n3">
      <v-col cols="12">
        <p class="texto-corrido">
          Nessa página você pode visualizar todas as análises que foram salvas por você. Basta clicar no nome da análise para visualizar as faixas e os produtos
          analisados.
        </p>
      </v-col>
    </v-row>
    <v-row class="px-4">
      <v-spacer />
      <mf-button icon="add" label="Nova análise" @click="redirect" />
    </v-row>
    <v-card class="mt-5">
      <v-card-text>
        <v-row>
          <v-col cols="12" class="pa-0">
            <v-row class="px-5">
              <v-col cols="9">
                <h3 class="table-card-title">Suas análises salvas</h3>
              </v-col>
              <v-col cols="3">
                <mf-search v-model="search" class="pt-0 mt-0" placeholder="Busque por uma análise" hide-details />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <paginated-data-table
              :key="paginatedDataTableKey"
              :headers="headers"
              :query="query"
              :custom-items-per-page="10"
              :search="search"
              :query-variables="queryVariables"
              queryName="priceRangesAnalyticsList"
              no-data-text="Não há dados a serem exibidos"
            >
              <template v-slot:item="{ item }">
                <tr>
                  <td>
                    <a class="link link-color" @click="editPriceRange(item._id)">
                      {{ item.name }}
                    </a>
                  </td>
                  <td class="texto-corrido">{{ item.description }}</td>
                  <td class="texto-corrido">{{ formatType(item.type) }}</td>
                  <td class="texto-corrido">{{ item.products_count }}</td>
                  <td class="texto-corrido">{{ item.ranges_count }}</td>
                  <td class="texto-corrido">{{ getSafe(() => item.units.length) || 'Todas' }}</td>
                  <td class="texto-corrido">{{ DateTime.fromISO(item.created_at).toFormat('dd/MM/yyyy') }}</td>
                  <td class="texto-corrido">{{ DateTime.fromISO(item.updated_at).toFormat('dd/MM/yyyy') }}</td>
                  <td class="text-right">
                    <v-menu bottom origin="center center" transition="scale-transition">
                      <template v-slot:activator="{ on }">
                        <mf-button color="cinza-0" icon="more_vert" type="icon" v-on:click.native="on.click" />
                      </template>
                      <v-list>
                        <v-list-item data-cy="editContact" @click="editPriceRange(item._id)">
                          <v-list-item-title>Editar</v-list-item-title>
                        </v-list-item>
                        <v-list-item data-cy="deleteContactConfirmModal" @click="deletePriceRange(item._id)">
                          <v-list-item-title>Deletar</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </td>
                </tr>
              </template>
            </paginated-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </base-page-layout>
</template>

<script>
import { QUERY_PRICE_RANGES_ANALYTICS_LIST, MUTATION_DELETE_PRICE_RANGE_ANALYTICS } from '../../graphql'
import BasePageLayout from '@/components/BasePageLayout.vue'
import PaginatedDataTable from '@/components/PaginatedDataTable.vue'
import { DateTime } from 'luxon'
import { priceRangeMixin } from '../../mixins/price-range-mixin'
import { mapState } from 'vuex'

export default {
  name: 'PriceRange',
  components: {
    BasePageLayout,
    PaginatedDataTable,
  },
  mixins: [priceRangeMixin],
  data: () => ({
    search: '',
    DateTime: DateTime,
    paginatedDataTableKey: 0,
  }),
  computed: {
    ...mapState({
      unitsFilters: (state) => state.filters.units || [],
      productsFilters: (state) => state.filters.products,
    }),
    headers() {
      return [
        {
          text: 'Nome',
          value: 'name',
          class: 'table-header',
          width: '212px',
        },
        {
          text: 'Descrição',
          value: 'description',
          class: 'table-header',
          width: '212px',
        },
        {
          text: 'Tipo de análise',
          value: 'type',
          class: 'table-header',
        },
        {
          text: 'Produtos',
          value: 'products_count',
          class: 'table-header',
        },
        {
          text: 'Faixas',
          value: 'ranges_count',
          class: 'table-header',
        },
        {
          text: 'Lojas',
          value: 'units',
          class: 'table-header',
        },
        {
          text: 'Data de criação',
          value: 'created_at',
          class: 'table-header',
        },
        {
          text: 'Última atualização',
          value: 'updated_at',
          class: 'table-header',
        },
        {
          text: '',
          value: '_id',
        },
      ]
    },
    queryVariables() {
      return {
        units: this.unitsFilters,
        products: this.productsFilters,
      }
    },
    query() {
      return QUERY_PRICE_RANGES_ANALYTICS_LIST
    },
  },
  methods: {
    formatType(type) {
      const types = {
        PRODUCTS: 'Produtos',
        CAMPAIGN: 'Campanha',
      }

      return types[type]
    },
    redirect() {
      this.forcePush = true
      this.$router.push({ name: 'Nova análise' })
    },
    async deletePriceRange(_id) {
      const confirmed = await this.$confirm({
        title: 'Remover análise',
        message: 'Tem certeza que deseja remover esta análise?',
        confirmText: 'Remover',
        confirmColor: 'vermelho-d20',
        cancelText: 'Cancelar',
      })
        .then(() => true)
        .catch(() => false)
      if (!confirmed) return
      try {
        await this.$apollo.query({
          query: MUTATION_DELETE_PRICE_RANGE_ANALYTICS,
          variables: {
            _id,
          },
          fetchPolicy: 'no-cache',
        })
        this.$snackbar({ message: 'Análise apagada com sucesso.', snackbarColor: 'success' })
        this.paginatedDataTableKey += 1
      } catch (error) {
        console.log(error)
      }
    },
    editPriceRange(id) {
      this.forcePush = true
      this.$router.push({ path: `/produtos/faixas-precos/${id}` })
    },
  },
}
</script>

<style lang="scss">
.table-header {
  font-size: 14px !important;
  color: $cinza-d10 !important;
}
.button-size {
  font-size: 18px !important;
}
.link-color {
  color: $marca-0-l40 !important;
}
</style>
